export const mutationTypes = {
	CONTACTS_LOAD: 'CONTACTS_LOAD',
	CONTACTS_CREATE: 'CONTACTS_CREATE',
	CONTACTS_DESTROY: 'CONTACTS_DESTROY'
};

export default {
	[mutationTypes.CONTACTS_LOAD](state, data) {
		state.items = data
	},
	[mutationTypes.CONTACTS_CREATE](state, data) {
		state.items.push(data)
	},
	[mutationTypes.CONTACTS_DESTROY](state, data) {
		const i = state.items.findIndex(item => item.id == data.id)
		state.items.splice(i,1)
	}	
};
